// Industry detailed content from documents

export const industryContent: Record<string, any> = {
  dairy: {
    meta: {
      title_gr: "Γαλακτοκομικά | Ολοκληρωμένες Λύσεις Παραγωγής & Συσκευασίας | TFT",
      title_en: "Dairy | Complete Production & Packaging Solutions | TFT",
      description_gr: "Η TFT διαθέτει περισσότερα από 60 χρόνια εμπειρίας στον γαλακτοκομικό κλάδο, προσφέροντας ολοκληρωμένες λύσεις για την επεξεργασία, αυτοματοποίηση και συσκευασία γαλακτοκομικών προϊόντων.",
      description_en: "With over 60 years of experience in the dairy industry, TFT provides complete process, automation and packaging solutions for milk-based products."
    },
    overview: {
      el: "Η TFT υποστηρίζει τη γαλακτοβιομηχανία με ολοκληρωμένες τεχνικές λύσεις που καλύπτουν όλο το εύρος της παραγωγικής διαδικασίας, από την επεξεργασία της πρώτης ύλης έως την τελική συσκευασία. Ο σχεδιασμός των λύσεών μας βασίζεται στην κατανόηση των διεργασιών, των απαιτήσεων υγιεινής και των στόχων απόδοσης κάθε μονάδας.\n\nΔιαθέτουμε εμπειρία σε όλες τις βασικές κατηγορίες γαλακτοκομικών προϊόντων – γάλα, γιαούρτι, τυριά, παγωτό και βούτυρο – με έμφαση στη σταθερότητα διεργασιών, την επαναληψιμότητα ποιότητας, την ενεργειακή αποδοτικότητα και τη μακροχρόνια αξιοπιστία λειτουργίας.",
      en: "TFT supports the dairy industry with integrated technical solutions covering the entire production process, from raw material processing to final packaging. Our solutions are designed based on a deep understanding of process requirements, hygienic design principles, and plant performance objectives.\n\nWe have extensive experience across all major dairy product categories — milk, yogurt, cheese, ice cream, and butter — focusing on process stability, consistent product quality, energy efficiency, and long-term operational reliability."
    },
    process: [
      { 
        category: { el: "Επεξεργασία Γάλακτος", en: "Milk Processing" }, 
        description: { el: "Παραλαβή, θερμική επεξεργασία, ομογενοποίηση και ενσωματωμένα συστήματα CIP/SIP για ασφαλή και σταθερή επεξεργασία γάλακτος.", en: "Reception, thermal treatment, homogenization, and integrated CIP/SIP systems to ensure safe and consistent milk processing." }
      },
      { 
        category: { el: "Παραγωγή Γαλακτοκομικών Προϊόντων", en: "Dairy Product Manufacturing" }, 
        description: { el: "Λύσεις επεξεργασίας για γιαούρτι, τυριά, βούτυρο και παγωτό, προσαρμοσμένες στα ιδιαίτερα χαρακτηριστικά κάθε προϊόντος.", en: "Processing solutions for yogurt, cheese, butter, and ice cream, designed to support different product characteristics and production requirements." }
      },
      { 
        category: { el: "Αυτοματισμοί Διεργασιών", en: "Process Automation" }, 
        description: { el: "Ακριβής παρακολούθηση και έλεγχος των διεργασιών μέσω συστημάτων SCADA και MES.", en: "Precise process monitoring and control through SCADA and MES systems for stable and repeatable production." }
      },
      { 
        category: { el: "Ενεργειακή Απόδοση & Υγιεινός Σχεδιασμός", en: "Energy Efficiency & Hygienic Design" }, 
        description: { el: "Ενεργειακά αποδοτικές λύσεις σε συνδυασμό με υγιεινό σχεδιασμό εξοπλισμού και εγκαταστάσεων για αξιόπιστη και βιώσιμη λειτουργία.", en: "Energy-efficient solutions combined with hygienic equipment and plant design to support sustainable and reliable operation." }
      }
    ],
    packaging: [
      { 
        product: { el: "Πρωτογενής Συσκευασία", en: "Primary Packaging" }, 
        type: { el: "Χάρτινη πολυστρωματική συσκευασία, φιάλες, κύπελλα, δοχεία, foil", en: "Bottles, cups, containers, foil, carton" }, 
        capacity: { el: "Ευέλικτες λύσεις συσκευασίας που υποστηρίζουν διαφορετικές παραγωγικές δυναμικότητες", en: "Flexible packaging formats supporting a wide range of production capacities" }
      },
      { 
        product: { el: "Δευτερογενής Συσκευασία", en: "Secondary Packaging" }, 
        type: { el: "Κιβώτια, multipack, wrap-around", en: "Cases, multipacks, wrap-around" }, 
        capacity: { el: "Αυτοματοποιημένα συστήματα επισυσκευασίας για αποδοτική λειτουργία end-of-line", en: "Automated end-of-line systems for efficient and reliable packaging" }
      },
      { 
        product: { el: "Επισήμανση & Ιχνηλασιμότητα", en: "Labeling & Traceability" }, 
        type: { el: "Ημερομηνία, κωδικοποίηση, ιχνηλασιμότητα", en: "Date coding, labeling, traceability" }, 
        capacity: { el: "Πλήρης έλεγχος παρτίδας και αναγνώριση προϊόντος σε όλη την παραγωγική διαδικασία", en: "Full batch control and product identification throughout the production process" }
      }
    ],
    qualityControlOverview: [
      { 
        category: { el: "In-Line Παρακολούθηση", en: "In-Line Monitoring" }, 
        application: { el: "Συνεχής έλεγχος διεργασιών", en: "Continuous process control" },
        description: { el: "Παρακολούθηση κρίσιμων παραμέτρων παραγωγής σε πραγματικό χρόνο", en: "Real-time monitoring of critical process parameters during production" }
      },
      { 
        category: { el: "Εργαστηριακές Αναλύσεις", en: "Laboratory Analysis" }, 
        application: { el: "Ποιοτικός & μικροβιολογικός έλεγχος", en: "Quality & microbiological testing" },
        description: { el: "Έλεγχος σύστασης, ασφάλειας και συμμόρφωσης προϊόντων", en: "Verification of product composition, safety, and compliance" }
      },
      { 
        category: { el: "Ιχνηλασιμότητα & Συμμόρφωση", en: "Traceability & Compliance" }, 
        application: { el: "Έλεγχος παρτίδων & δεδομένων", en: "Batch control & data management" },
        description: { el: "Πλήρης ιχνηλασιμότητα παρτίδων σύμφωνα με διεθνή πρότυπα ασφάλειας τροφίμων", en: "Full batch traceability in accordance with international food safety standards" }
      },
      { 
        category: { el: "Υποστήριξη Αποφάσεων", en: "Decision Support" }, 
        application: { el: "Βελτιστοποίηση παραγωγής", en: "Production optimization" },
        description: { el: "Αξιόπιστα δεδομένα για τεκμηριωμένες αποφάσεις και σταθερή ποιότητα", en: "Reliable data to support informed decisions and consistent product quality" }
      }
    ],
    turnkey: {
      title: {
        el: "Turnkey Solutions",
        en: "Turnkey Solutions"
      },
      description: {
        el: "Με πολυετή εμπειρία στον γαλακτοκομικό κλάδο, η TFT αναλαμβάνει ολοκληρωμένα έργα 'με το κλειδί στο χέρι' για παραγωγικές μονάδες γάλακτος, γιαουρτιού, τυριών, παγωτού και βουτύρου. Από τη μελέτη και τον σχεδιασμό μέχρι την εγκατάσταση, την έναρξη λειτουργίας και την τεχνική υποστήριξη, παραδίδουμε εργοστάσια και γραμμές παραγωγής έτοιμες προς χρήση.",
        en: "With many years of experience in the dairy sector, TFT undertakes complete turnkey projects for milk, yoghurt, cheese, ice cream and butter production facilities. From study and design to installation, commissioning and technical support, we deliver factories and production lines ready to use."
      },
      highlights: {
        el: [
          "Ηγετική παρουσία στο dairy: από το 1963 εξοπλίζουμε τις μεγαλύτερες γαλακτοβιομηχανίες της Ελλάδας",
          "Συνεργασίες με κορυφαίους οίκους: SPX FLOW/APV/Seital (process), Elopak, Galdi, Buhmann, Roboteh (packaging)",
          "Εμπειρία σε όλα τα προϊόντα: φρέσκο & μακράς διαρκείας γάλα, γιαούρτι, φέτα, αλοιφώδη ημίσκληρα και σκληρά τυριά, βούτυρο και παγωτό"
        ],
        en: [
          "Leading presence in dairy: since 1963 we have equipped the largest dairy industries in Greece",
          "Partnerships with leading companies: SPX FLOW/APV/Seital (process), Elopak, Galdi, Buhmann, Roboteh (packaging)",
          "Experience in all products: fresh & long-life milk, yoghurt, feta, spreadable semi-hard and hard cheeses, butter and ice cream"
        ]
      },
      scope: {
        el: [
          "Μελέτη & Σχεδιασμός Εργοστασίου – Ανάλυση δυναμικότητας, ροής παραγωγής και προοπτικών ανάπτυξης",
          "Διαχείριση Έργου (Project Management) – Συντονισμός μηχανικών, προμηθευτών και εργολάβων",
          "Κατασκευή & Εγκατάσταση – Προμήθεια εξοπλισμού, σωληνώσεις, αυτοματισμοί",
          "Commissioning – Θέση σε λειτουργία με δοκιμές απόδοσης",
          "Εκπαίδευση & Υποστήριξη – Παράδοση manuals, εκπαίδευση προσωπικού και after-sales"
        ],
        en: [
          "Factory Study & Design – Capacity analysis, production flow and development prospects",
          "Project Management – Coordination of engineers, suppliers and contractors",
          "Construction & Installation – Equipment supply, piping, automation",
          "Commissioning – Start-up with performance tests",
          "Training & Support – Manuals delivery, staff training and after-sales"
        ]
      }
    },
    processEquipment: {
      title: {
        el: "Εξοπλισμός Επεξεργασίας",
        en: "Process Equipment"
      },
      description: {
        el: "Η TFT αντιπροσωπεύει αποκλειστικά την SPX FLOW (APV & Seital) για την προμήθεια κρίσιμων μηχανημάτων διεργασίας στην γαλακτοκομική βιομηχανία.",
        en: "TFT exclusively represents SPX FLOW (APV & Seital) for the supply of critical process equipment in the dairy industry."
      },
      categories: [
        {
          name: {
            el: "Separators & Homogenisers",
            en: "Separators & Homogenisers"
          },
          equipment: [
            {
              name: "Seital Self-Cleaning Separators",
              useCase: {
                el: "Διαχωρισμός γάλακτος, clarification τυρογάλακτος, cream skimming",
                en: "Milk separation, whey clarification, cream skimming"
              },
              specs: {
                el: "CIP, ροές 500–70.000 L/h, υγιεινή κατασκευή",
                en: "CIP, flows 500–70,000 L/h, hygienic construction"
              }
            },
            {
              name: "APV Gaulin / Rannie 275Q",
              useCase: {
                el: "Μεγάλες γραμμές γάλακτος & παγωτού",
                en: "Large milk & ice cream lines"
              },
              specs: {
                el: "Πίεση έως 400 bar, ροή έως 55.000 L/h",
                en: "Pressure up to 400 bar, flow up to 55,000 L/h"
              }
            },
            {
              name: "APV Pilot 4T",
              useCase: {
                el: "Πιλοτική παραγωγή / batch tests",
                en: "Pilot production / batch tests"
              },
              specs: {
                el: "Μικρή κλίμακα, ευελιξία πίεσης",
                en: "Small scale, pressure flexibility"
              }
            },
            {
              name: "APV Lab 15MR / 31MR",
              useCase: {
                el: "Έρευνα & ανάπτυξη",
                en: "Research & development"
              },
              specs: {
                el: "Πολύ χαμηλή ροή, ακρίβεια δείγματος",
                en: "Very low flow, sample accuracy"
              }
            }
          ]
        },
        {
          name: {
            el: "Αντλίες & Βαλβίδες",
            en: "Pumps & Valves"
          },
          equipment: [
            {
              name: "APV W+ Series (Centrifugal Pump)",
              useCase: {
                el: "Μεταφορά γάλακτος, κρέμας, χαμηλού ιξώδους υγρών",
                en: "Transfer of milk, cream, low viscosity liquids"
              },
              specs: {
                el: "CIP cleanable, έως 1.800 m³/h, υγιεινός σχεδιασμός",
                en: "CIP cleanable, up to 1,800 m³/h, hygienic design"
              }
            },
            {
              name: "APV DW Series (Positive Displacement)",
              useCase: {
                el: "Προϊόντα υψηλού ιξώδους (γιαούρτι, συμπυκνώματα)",
                en: "High viscosity products (yoghurt, concentrates)"
              },
              specs: {
                el: "Gentle handling, υψηλή απόδοση",
                en: "Gentle handling, high efficiency"
              }
            },
            {
              name: "APV DELTA M4/MX (Mixproof Valve)",
              useCase: {
                el: "Διαχωρισμός προϊόντος & CIP",
                en: "Product separation & CIP"
              },
              specs: {
                el: "Διπλής έδρας, αυξημένη ασφάλεια",
                en: "Double seat, increased safety"
              }
            },
            {
              name: "APV DELTA SV/SVS (Single Seat Valve)",
              useCase: {
                el: "Κατευθυνόμενη ροή προϊόντος & CIP",
                en: "Directional product flow & CIP"
              },
              specs: {
                el: "Modular design",
                en: "Modular design"
              }
            },
            {
              name: "APV DELTA BV (Butterfly Valve)",
              useCase: {
                el: "Απλή on/off ροή (γάλα, νερό, CIP)",
                en: "Simple on/off flow (milk, water, CIP)"
              },
              specs: {
                el: "Ανοξείδωτη κατασκευή, οικονομική",
                en: "Stainless steel construction, economical"
              }
            }
          ]
        },
        {
          name: {
            el: "Εναλλάκτες Θερμότητας",
            en: "Heat Exchangers"
          },
          equipment: [
            {
              name: "APV ParaFlow (Plate Heat Exchanger)",
              useCase: {
                el: "Παστερίωση γάλακτος, κρέμας, χυμών",
                en: "Pasteurization of milk, cream, juices"
              },
              specs: {
                el: "Υψηλή απόδοση, εύκολος καθαρισμός, compact design",
                en: "High efficiency, easy cleaning, compact design"
              }
            },
            {
              name: "APV Hybrid / T tubular (Tubular Heat Exchanger)",
              useCase: {
                el: "Θέρμανση/ψύξη υψηλού ιξώδους προϊόντων (γιαούρτι, συμπυκνωμένα)",
                en: "Heating/cooling high viscosity products (yoghurt, concentrates)"
              },
              specs: {
                el: "Ισχυρή αντοχή, χαμηλή πτώση πίεσης",
                en: "Strong resistance, low pressure drop"
              }
            },
            {
              name: "APV Consistator (Scraped Surface Heat Exchanger)",
              useCase: {
                el: "Προϊόντα υψηλού ιξώδους (γιαούρτι με φρούτο, σάλτσες)",
                en: "High viscosity products (fruit yoghurt, sauces)"
              },
              specs: {
                el: "Συνεχής απόξεση επιφανείας, αποφυγή καραμελοποίησης",
                en: "Continuous surface scraping, prevents caramelization"
              }
            },
            {
              name: "APV UHT Systems (Plate & Frame)",
              useCase: {
                el: "UHT/ESL εφαρμογές σε γάλα & ροφήματα",
                en: "UHT/ESL applications in milk & beverages"
              },
              specs: {
                el: "Συνδυασμός θερμικής επεξεργασίας με CIP",
                en: "Combination of thermal processing with CIP"
              }
            }
          ]
        },
        {
          name: {
            el: "Εξειδικευμένες Λύσεις",
            en: "Specialized Solutions"
          },
          equipment: [
            {
              name: {
                el: "Παραγωγή Τυριών",
                en: "Cheese Production"
              },
              useCase: {
                el: "Παραγωγή φρέσκων, ημίσκληρων & σκληρών τυριών",
                en: "Production of fresh, semi-hard & hard cheeses"
              },
              specs: {
                el: "Δεξαμενές πήξης, πλήρεις γραμμές τυροκομίας, modular σχεδιασμός",
                en: "Coagulation tanks, complete cheese production lines, modular design"
              }
            },
            {
              name: {
                el: "Ψύξη Γιαουρτιού",
                en: "Yogurt Cooling"
              },
              useCase: {
              el: "Ταχεία ψύξη γιαουρτιού",
              en: "Rapid yoghurt cooling"
              },
              specs: {
                el: "Μείωση χρόνου ψύξης έως 75%, ομοιόμορφη ψύξη, ενεργειακή αποδοτικότητα",
                en: "Cooling time reduction up to 75%, uniform cooling, energy efficiency"
              }
            },
            {
              name: {
                el: "Παραγωγή Βουτύρου",
                en: "Butter Production"
              },
              useCase: {
                el: "Παραγωγή & τυποποίηση βουτύρου",
                en: "Butter production & standardization"
              },
              specs: {
                el: "Συνεχείς γραμμές παραγωγής, σταθερή ποιότητα, απαλή κατεργασία",
                en: "Continuous production lines, consistent quality, gentle processing"
              }
            },
            {
              name: {
                el: "Συμπύκνωση",
                en: "Concentration"
              },
              useCase: {
                el: "UF, NF, RO & MF μονάδες για γάλα & τυρόγαλα",
                en: "UF, NF, RO & MF units for milk & whey"
              },
              specs: {
                el: "Υψηλή εκλεκτικότητα, modular skid-mounted, ενεργειακή απόδοση",
                en: "High selectivity, modular skid-mounted, energy efficiency"
              }
            }
          ]
        }
      ]
    },
    subcategories: {
      milk: {
        title: {
          el: "Γάλα",
          en: "Milk"
        },
        description: {
          el: "Ολοκληρωμένες λύσεις για παραγωγή φρέσκου και μακράς διαρκείας γάλακτος",
          en: "Complete solutions for fresh and long-life milk production"
        },
        process: [
          {
            name: "Seital Separators",
            specs: {
              el: "Διαχωρισμός γάλακτος, cream skimming, 500–70.000 L/h",
              en: "Milk separation, cream skimming, 500–70,000 L/h"
            }
          },
          {
            name: "APV Homogenizers",
            specs: {
              el: "Ομογενοποίηση γάλακτος, πίεση έως 400 bar",
              en: "Milk homogenization, pressure up to 400 bar"
            }
          },
          {
            name: "APV ParaFlow Heat Exchangers",
            specs: {
              el: "Παστερίωση & UHT επεξεργασία",
              en: "Pasteurization & UHT processing"
            }
          }
        ],
        packaging: [
          {
            type: {
              el: "Χαρτοκυτία Gable Top (Elopak)",
              en: "Gable Top Cartons (Elopak)"
            },
            formats: "Pure-Pak® Mini/Standard/Large (250–2.000 ml)",
            capacity: "3.000–14.000 τμχ./ώρα / pcs/h"
          },
          {
            type: {
              el: "PET/HDPE Μπουκάλια",
              en: "PET/HDPE Bottles"
            },
            formats: "250ml–2L",
            capacity: "6.000–18.000 τμχ./ώρα / pcs/h"
          }
        ]
      },
      yoghurt: {
        title: {
          el: "Γιαούρτι",
          en: "Yoghurt"
        },
        description: {
          el: "Λύσεις για παραγωγή και συσκευασία γιαουρτιού",
          en: "Solutions for yoghurt production and packaging"
        },
        process: [
          {
            name: "APV Heat Exchangers",
            specs: {
              el: "Θέρμανση yoghurt mix, ψύξη",
              en: "Yoghurt mix heating, cooling"
            }
          },
          {
            name: {
              el: "Ταχεία Ψύξη",
              en: "Rapid Cooling"
            },
            specs: {
              el: "Αυτόματα ψυκτικά τούνελ, μείωση χρόνου έως 75%",
              en: "Automatic cooling tunnels, time reduction up to 75%"
            }
          }
        ],
        packaging: [
          {
            type: {
              el: "Προκατασκευασμένα Κύπελλα (Clean & Ultra-Clean)",
              en: "Pre-made Cups (Clean & Ultra-Clean)"
            },
            capacity: "2.400–14.000 τμχ./ώρα (rotary) / pcs/h (rotary)"
          },
          {
            type: {
              el: "Προκατασκευασμένα Κύπελλα (Aseptic & Ultra-Clean)",
              en: "Pre-made Cups (Aseptic & Ultra-Clean)"
            },
            capacity: "3.000–70.000 τμχ./ώρα (in-line) / pcs/h (in-line)"
          }
        ]
      },
      cheese: {
        title: {
          el: "Τυρί",
          en: "Cheese"
        },
        description: {
          el: "Εξοπλισμός για παραγωγή φρέσκων, ημίσκληρων και σκληρών τυριών",
          en: "Equipment for fresh, semi-hard and hard cheese production"
        },
        process: [
          {
            name: {
              el: "Δεξαμενές Πήξης",
              en: "Coagulation Tanks"
            },
            specs: {
              el: "Παραγωγή φρέσκων, ημίσκληρων & σκληρών τυριών, υγιεινή κατασκευή",
              en: "Fresh, semi-hard & hard cheese production, hygienic construction"
            }
          },
          {
            name: {
              el: "Γραμμές Τυροκομίας",
              en: "Cheese Production Lines"
            },
            specs: {
              el: "Πλήρεις γραμμές, modular σχεδιασμός",
              en: "Complete lines, modular design"
            }
          },
          {
            name: {
              el: "Θάλαμοι Ωρίμανσης",
              en: "Ripening Chambers"
            },
            specs: {
              el: "Έλεγχος θερμοκρασίας & υγρασίας",
              en: "Temperature & humidity control"
            }
          }
        ],
        packaging: [
          {
            type: {
              el: "Φέτα με Άλμη",
              en: "Feta in Brine"
            },
            formats: {
              el: "Πλαστικά δοχεία με καπάκι",
              en: "Plastic containers with lid"
            },
            capacity: "1.000–8.000 τμχ./ώρα / pcs/h"
          }
        ]
      },
      butter: {
        title: {
          el: "Βούτυρο",
          en: "Butter"
        },
        description: {
          el: "Λύσεις για παραγωγή και συσκευασία βουτύρου",
          en: "Solutions for butter production and packaging"
        },
        process: [
          {
            name: {
              el: "Συνεχείς Γραμμές Παραγωγής",
              en: "Continuous Production Lines"
            },
            specs: {
              el: "Αποαερωτές, συστήματα αναμίξεων, σταθερή ποιότητα",
              en: "Deaerators, mixing systems, consistent quality"
            }
          }
        ],
        packaging: [
          {
            type: {
              el: "Παραλληλόγραμμα/Τετράγωνα Μπλοκ",
              en: "Rectangular/Square Blocks"
            },
            formats: "200–500g wrapped packs",
            capacity: "100–250 πακέτα/λεπτό / packs/min"
          },
          {
            type: {
              el: "Κυλινδρικά (rolls, τούβλα)",
              en: "Cylindrical (rolls, bricks)"
            },
            capacity: "80–200 πακέτα/λεπτό / packs/min"
          }
        ]
      },
      "ice-cream": {
        title: {
          el: "Παγωτό",
          en: "Ice Cream"
        },
        description: {
          el: "Εξοπλισμός για παραγωγή παγωτού",
          en: "Equipment for ice cream production"
        },
        process: [
          {
            name: "APV Homogenizers",
            specs: {
              el: "Ομογενοποίηση ice cream mix",
              en: "Ice cream mix homogenization"
            }
          },
          {
            name: "Freezers",
            specs: {
              el: "Freon (R448): 450-2.000 L/h, CO₂ (R744): 700-4.000 L/h, Αμμωνία (NH₃): 20-4.500 L/h",
              en: "Freon (R448): 450-2,000 L/h, CO₂ (R744): 700-4,000 L/h, Ammonia (NH₃): 20-4,500 L/h"
            }
          }
        ]
      }
    },
    qualityControl: {
      title: {
        el: "Εξοπλισμός Ποιοτικού Ελέγχου",
        en: "Quality Control Equipment"
      },
      description: {
        el: "Η TFT προσφέρει προηγμένα αναλυτικά όργανα για τον ποιοτικό έλεγχο γάλακτος και γαλακτοκομικών προϊόντων σε συνεργασία με τη FOSS.",
        en: "TFT offers advanced analytical instruments for quality control of milk and dairy products in partnership with FOSS."
      },
      instruments: [
        {
          name: "FOSS MilkoScan™",
          application: {
            el: "Ανάλυση γάλακτος (λίπος, πρωτεΐνη, λακτόζη, στερεά)",
            en: "Milk analysis (fat, protein, lactose, solids)"
          },
          features: {
            el: "FTIR τεχνολογία, ταχεία ανάλυση, ISO/IDF",
            en: "FTIR technology, rapid analysis, ISO/IDF"
          }
        },
        {
          name: "FOSS Fossomatic™",
          application: {
            el: "Μέτρηση σωματικών κυττάρων (SCC) σε γάλα",
            en: "Somatic cell count (SCC) measurement in milk"
          },
          features: {
            el: "Φθορισμομετρία, γρήγορη εκτίμηση μαστίτιδας",
            en: "Fluorescence, rapid mastitis assessment"
          }
        },
        {
          name: "FOSS BactoScan™",
          application: {
            el: "Μέτρηση μικροβιακού φορτίου (CFU/ml)",
            en: "Bacterial count measurement (CFU/ml)"
          },
          features: {
            el: "Αποτελέσματα σε λεπτά, ISO 16140",
            en: "Results in minutes, ISO 16140"
          }
        },
        {
          name: "FOSS FoodScan™",
          application: {
            el: "Ανάλυση γιαουρτιού, τυριού, βουτύρου",
            en: "Analysis of yoghurt, cheese, butter"
          },
          features: {
            el: "NIR τεχνολογία, λιπαρά, υγρασία, πρωτεΐνη, αλάτι",
            en: "NIR technology, fat, moisture, protein, salt"
          }
        },
        {
          name: "FOSS CombiFoss™",
          application: {
            el: "Συνδυασμός MilkoScan + Fossomatic",
            en: "Combination MilkoScan + Fossomatic"
          },
          features: {
            el: "Ολοκληρωμένη εικόνα ποιότητας γάλακτος",
            en: "Complete milk quality picture"
          }
        },
        {
          name: "FOSS ProFoss™",
          application: {
            el: "In-line NIR monitoring – Συνεχής παρακολούθηση παραμέτρων σε ροή",
            en: "In-line NIR monitoring – Continuous parameter monitoring in flow"
          },
          features: {
            el: "Real-time ανάλυση κατά την παραγωγή",
            en: "Real-time analysis during production"
          }
        }
      ],
      microbiology: {
        title: {
          el: "Μικροβιολογικός Έλεγχος",
          en: "Microbiological Control"
        },
        description: {
          el: "Ολοκληρωμένες λύσεις για σχεδιασμό, εξοπλισμό και υποστήριξη μικροβιολογικών εργαστηρίων",
          en: "Complete solutions for design, equipment and support of microbiological laboratories"
        },
        systems: [
          {
            name: "Real-Time PCR Kits",
            application: {
              el: "Ανίχνευση παθογόνων (Listeria, Salmonella, E. coli O157:H7)",
              en: "Pathogen detection (Listeria, Salmonella, E. coli O157:H7)"
            },
            features: {
              el: "Ταχύτητα (8–24 ώρες), ακρίβεια & ευαισθησία",
              en: "Speed (8–24 hours), accuracy & sensitivity"
            }
          },
          {
            name: "PCR Prep Automation",
            application: {
              el: "Αυτόματη προετοιμασία δειγμάτων PCR",
              en: "Automated PCR sample preparation"
            },
            features: {
              el: "Μείωση χρόνου hands-on, αυξημένη ακρίβεια",
              en: "Reduced hands-on time, increased accuracy"
            }
          },
          {
            name: "Chromogenic Media",
            application: {
              el: "Καλλιέργεια/ταυτοποίηση παθογόνων μικροοργανισμών",
              en: "Culture/identification of pathogenic microorganisms"
            },
            features: {
              el: "Ταχεία & εύκολη ανίχνευση παθογόνων",
              en: "Rapid & easy pathogen detection"
            }
          }
        ]
      }
    },
    endOfLine: {
      title: {
        el: "Λύσεις Επισυσκευασίας (End-of-Line)",
        en: "End-of-Line Packaging Solutions"
      },
      equipment: [
        {
          type: "Wrap-Around Case Packers",
          applications: {
            el: "Χαρτοκυτία γάλακτος, κυπελλάκια γιαουρτιού, PET/HDPE μπουκάλια",
            en: "Milk cartons, yoghurt cups, PET/HDPE bottles"
          },
          capacity: "~25.000 τμχ./ώρα / ~25,000 pcs/h"
        },
        {
          type: "American Box Solutions",
          applications: {
            el: "Γιαούρτι, γάλα, multipacks",
            en: "Yoghurt, milk, multipacks"
          },
          capacity: "~20.000 τμχ./ώρα / ~20,000 pcs/h"
        },
        {
          type: "Tray Packers",
          applications: {
            el: "Multipacks cups, μπουκάλια",
            en: "Multipacks cups, bottles"
          },
          capacity: "~18.000 τμχ./ώρα / ~18,000 pcs/h"
        },
        {
          type: "Shrink-Wrapping",
          applications: {
            el: "Multipacks cups, bottles, cartons",
            en: "Multipacks cups, bottles, cartons"
          },
          capacity: "~22.000 τμχ./ώρα / ~22,000 pcs/h"
        },
        {
          type: "Palletizing",
          applications: {
            el: "Όλα τα τελικά προϊόντα γαλακτοκομικών",
            en: "All dairy final products"
          },
          capacity: "~200 κιβώτια/ώρα ανά ρομπότ / ~200 cases/h per robot"
        }
      ]
    }
  },
  beverage: {
    overview: {
      el: "Η TFT υποστηρίζει τη βιομηχανία ποτών με πλήρεις λύσεις επεξεργασίας (process), εμφιάλωσης/πλήρωσης (packaging) και επισυσκευασίας (end-of-line). Καλύπτουμε νερό, χυμούς, αναψυκτικά, μπύρα και οίνο.",
      en: "TFT supports the beverage industry with complete processing, filling/bottling and end-of-line solutions. We cover water, juices, soft drinks, beer and wine."
    },
    process: {
      title: "Process Equipment",
      equipment: [
        { category: "Separation", equipment: "Clarification & stabilization", applications: "Μπύρα, κρασί, cider" },
        { category: "Θερμική Επεξεργασία", equipment: "Flash Pasteurizers, UHT/ESL", applications: "Χυμοί, αναψυκτικά" },
        { category: "Φιλτράρισμα", equipment: "Micro/Ultra/Crossflow", applications: "Οίνος, μπύρα, χυμοί" }
      ]
    },
    packaging: {
      gableTop: { formats: "Pure-Pak® Mini/Standard (250–2.000 ml)", capacity: "3.000–14.000 τμχ./ώρα" },
      pet: { formats: "0.25L – 2L", capacity: "6.000–24.000 φιάλες/ώρα" },
      glass: { formats: "0.25L – 0.75L", capacity: "3.000–12.000 φιάλες/ώρα" }
    }
  },
  "bakery-grains-snacks": {
    overview: {
      el: "Η TFT υποστηρίζει τη βιομηχανία αρτοποιίας, προϊόντων δημητριακών και snacks με ολοκληρωμένες λύσεις παραγωγής και αυτοματοποίησης.\n\nΗ προσέγγιση εστιάζει στον σχεδιασμό αποδοτικών γραμμών παραγωγής που καλύπτουν ολόκληρη τη διαδικασία παραγωγής: διαχείριση πρώτων υλών, προετοιμασία και επεξεργασία ζύμης, μορφοποίηση προϊόντων, θερμική επεξεργασία, διαχείριση ροής προϊόντων, ποιοτικό έλεγχο και τελική συσκευασία.\n\nΟι λύσεις σχεδιάζονται με στόχο υψηλή σταθερότητα ποιότητας, αυξημένη παραγωγικότητα, αξιοπιστία λειτουργίας και ευελιξία παραγωγής.",
      en: "TFT supports the bakery, grain and snacks industry with complete production and automation solutions.\n\nThe approach focuses on designing efficient production lines covering the entire production process: raw material handling, dough preparation and processing, product forming, thermal processing, product flow management, quality control and final packaging.\n\nThe solutions are designed with goals of high quality stability, increased productivity, operational reliability and production flexibility."
    },
    applications: {
      title: { el: "Εφαρμογές", en: "Applications" },
      description: {
        el: "Οι τεχνολογικές λύσεις καλύπτουν ευρύ φάσμα εφαρμογών bakery και grain-based προϊόντων:",
        en: "Technological solutions cover a wide range of bakery and grain-based product applications:"
      },
      items: [
        "ψωμί και αρτοσκευάσματα",
        "ψωμί τοστ, ψωμάκια και φρυγανιές",
        "τορτίγιες και wraps",
        "βιενουαζερί και ζαχαροπλαστική",
        "μπισκότα, κράκερ και κουλουράκια",
        "κέικ, τηγανίτες και λουκουμάδες",
        "μπάρες δημητριακών και ενεργειακές μπάρες",
        "προϊόντα σνακ με βάση τα δημητριακά"
      ],
      en_items: [
        "bread and bakery products",
        "sandwich bread, buns and toast",
        "tortillas and wraps",
        "viennoiserie and pastry",
        "biscuits, crackers and cookies",
        "cakes, pancakes and donuts",
        "cereal bars and energy bars",
        "grain-based snack products"
      ]
    },
    process: {
      title: { el: "Λύσεις Επεξεργασίας", en: "Process Solutions" },
      sections: [
        {
          name: { el: "Διαχείριση Πρώτων Υλών", en: "Ingredient Handling" },
          description: {
            el: "Λύσεις για την αποθήκευση, μεταφορά και δοσομέτρηση πρώτων υλών.",
            en: "Solutions for storage, transport and dosing of raw materials."
          },
          functions: [
            "αποθήκευση πρώτων υλών σε σιλό",
            "πνευματική ή μηχανική μεταφορά υλικών",
            "σταθμοί εκφόρτωσης σακιών και μεγάλων σάκων",
            "ενσωματωμένο κοσκίνισμα υλικών",
            "παρτιδική ή συνεχής δοσομέτρηση",
            "ζύγιση και δοσολογία συστατικών",
            "διαχείριση δευτερευόντων συστατικών",
            "συστήματα ιχνηλασιμότητας"
          ],
          en_functions: [
            "raw material storage in silos",
            "pneumatic or mechanical material transport",
            "bag and big bag unloading stations",
            "inline sifting of materials",
            "batch or continuous dosing",
            "weighing and batching ingredients",
            "minor ingredients handling",
            "traceability systems"
          ]
        },
        {
          name: { el: "Ανάμιξη & Προετοιμασία Ζύμης", en: "Mixing & Dough Preparation" },
          description: {
            el: "Τεχνολογίες για την προετοιμασία ζύμης και την επεξεργασία πρώτων υλών. Οι λύσεις αυτές επιτρέπουν βελτιστοποίηση της διαδικασίας και σταθερότητα των χαρακτηριστικών της ζύμης.",
            en: "Technologies for dough preparation and raw material processing. These solutions enable process optimization and consistency in dough characteristics."
          },
          functions: [
            "παρτιδική και συνεχής ανάμιξη",
            "συστήματα προ-ανάμιξης",
            "συστήματα ζύμωσης",
            "αυτοματοποιημένα συστήματα ανάμιξης",
            "ενσωμάτωση προζυμιού και συστατικών",
            "έλεγχος συνθηκών παραγωγής"
          ],
          en_functions: [
            "batch and continuous mixing",
            "pre-mixing systems",
            "fermentation systems",
            "automated mixing systems",
            "pre-ferment and ingredients incorporation",
            "production conditions control"
          ]
        },
        {
          name: { el: "Επεξεργασία Ζύμης & Ψήσιμο", en: "Dough Processing & Baking" },
          description: {
            el: "Στάδια μορφοποίησης και θερμικής επεξεργασίας των προϊόντων. Οι λύσεις εξασφαλίζουν ομοιομορφία προϊόντος και υψηλή παραγωγική απόδοση.",
            en: "Forming and thermal processing stages of products. Solutions ensure product uniformity and high production efficiency."
          },
          functions: [
            "διαίρεση ζύμης",
            "μορφοποίηση προϊόντων",
            "φούσκωμα και ωρίμανση",
            "εφαρμογή επικαλύψεων ή χαράξεων",
            "βιομηχανικά συστήματα ψησίματος"
          ],
          en_functions: [
            "dough division",
            "product moulding",
            "proofing and maturation",
            "toppings or scoring application",
            "industrial baking systems"
          ]
        },
        {
          name: { el: "Διαχείριση Προϊόντων & Ροής", en: "Product Handling & Flow Management" },
          description: {
            el: "Μετά το ψήσιμο, τα προϊόντα μεταφέρονται σε συστήματα ψύξης και διαχείρισης ροής.",
            en: "After baking, products are transferred to cooling and flow management systems."
          },
          functions: [
            "συστήματα ψύξης προϊόντων",
            "μεταφορικές ταινίες",
            "αποθέματα και συσσωρευτές",
            "ευθυγράμμιση προϊόντων",
            "ομαδοποίηση και στοίβαξη"
          ],
          en_functions: [
            "product cooling systems",
            "conveyor belts",
            "buffers and accumulators",
            "product realignment",
            "grouping and stacking"
          ]
        },
        {
          name: { el: "Τεμαχισμός, Έλεγχος & Συσκευασία", en: "Slicing, Inspection & Packaging" },
          description: {
            el: "Στα τελικά στάδια της γραμμής παραγωγής ενσωματώνονται λύσεις για τεμαχισμό, ποιοτικό έλεγχο και συσκευασία.",
            en: "In the final stages of the production line, solutions for slicing, quality control and packaging are integrated."
          },
          functions: [
            "τεμαχισμός προϊόντων",
            "αυτοματοποιημένη φόρτωση σε μηχανές συσκευασίας",
            "ρομποτικά συστήματα διαχείρισης",
            "οπτικός έλεγχος",
            "ανίχνευση μετάλλων",
            "έλεγχος βάρους",
            "ακτινοσκόπηση (X-ray)"
          ],
          en_functions: [
            "product slicing",
            "automated loading into packaging machines",
            "robotic handling systems",
            "vision inspection",
            "metal detection",
            "checkweighing",
            "X-ray inspection"
          ]
        },
        {
          name: { el: "Τέλος Γραμμής & Δευτερογενής Συσκευασία", en: "End-of-Line & Secondary Packaging" },
          description: {
            el: "Λύσεις για την τελική συσκευασία και τη διαχείριση των προϊόντων.",
            en: "Solutions for final packaging and product handling."
          },
          functions: [
            "συσκευασία σε χαρτοκιβώτια",
            "θερμοσυστελλόμενη μεμβράνη",
            "συστήματα τοποθέτησης pick-and-place",
            "μεταφορικά συστήματα και αυτοματισμοί",
            "παλετοποίηση",
            "διαχείριση τέλους γραμμής"
          ],
          en_functions: [
            "carton packing",
            "shrink wrapping",
            "pick-and-place systems",
            "conveyors and automation",
            "palletizing",
            "end-of-line logistics"
          ]
        }
      ]
    }
  },
  "meat-fish-eggs": {
    overview: {
      el: "Η TFT υποστηρίζει τη βιομηχανία κρέατος, ψαριών και αυγών με λύσεις συσκευασίας και ποιοτικού ελέγχου.",
      en: "TFT supports the meat, fish and egg industry with packaging and quality control solutions."
    },
    packaging: [
      { product: "Υγρά αυγά", type: "Χαρτοκυτία Gable-Top", capacity: "3.000 – 12.000 τεμ./ώρα" },
      { product: "Υγρά αυγά", type: "Bag-in-Box", capacity: "300 – 1.200 packs/ώρα" }
    ],
    quality: [
      { instrument: "MeatScan™", application: "Ανάλυση κρέατος", features: "NIR τεχνολογία" },
      { instrument: "FoodScan™ 2", application: "Προϊόντα κρέατος", features: "Λιπαρά, πρωτεΐνη, αλάτι, υγρασία" }
    ]
  },
  "oils-fats": {
    overview: {
      el: "Η TFT προσφέρει εξειδικευμένες λύσεις για την παραγωγή και συσκευασία βρώσιμων ελαίων και λιπών (φυτικά έλαια, μαργαρίνες, βούτυρα, ειδικά λίπη).",
      en: "TFT offers specialized solutions for the production and packaging of edible oils and fats (vegetable oils, margarines, butters, specialty fats)."
    },
    process: [
      { 
        name: { el: "Κρυσταλλοποιητές", en: "Crystallizers" }, 
        application: { el: "Κρυσταλλοποίηση μαργαρίνης, βουτύρου", en: "Margarine, butter crystallization" }, 
        features: { el: "Υψηλή απόδοση, έλεγχος κρυστάλλωσης", en: "High efficiency, crystallization control" }
      },
      { 
        name: { el: "Ανάμειξη & Γαλακτωματοποίηση", en: "Mixing & Emulsification" }, 
        application: { el: "Σάλτσες, λιπαρά μείγματα", en: "Sauces, fat blends" }, 
        features: { el: "Ακριβής ομογενοποίηση", en: "Precise homogenization" }
      }
    ]
  },
  "spreads-sauces": {
    overview: {
      el: "Η TFT προσφέρει ολοκληρωμένες λύσεις για την παραγωγή και συσκευασία αλειμμάτων και σαλτσών (μαγιονέζα, κέτσαπ, μουστάρδα, σάλτσες ντομάτας, dressings).",
      en: "TFT offers complete solutions for the production and packaging of spreads and sauces (mayonnaise, ketchup, mustard, tomato sauces, dressings)."
    },
    process: [
      { 
        name: { el: "Ανάμειξη & Γαλακτωματοποίηση", en: "Mixing & Emulsification" }, 
        features: { el: "Υψηλή ομογενοποίηση, CIP δυνατότητα", en: "High homogenization, CIP capability" }
      },
      { 
        name: { el: "Θερμική Επεξεργασία", en: "Thermal Processing" }, 
        features: { el: "Παστερίωση, UHT", en: "Pasteurization, UHT" }
      },
      { 
        name: { el: "Μαγείρεμα & Ψύξη", en: "Cooking & Cooling" }, 
        features: { el: "Ακριβής έλεγχος θερμοκρασίας", en: "Precise temperature control" }
      }
    ]
  },
  "fruit-vegetables": {
    overview: {
      el: "Η TFT προσφέρει λύσεις για την συσκευασία φρούτων & λαχανικών (φρέσκων και επεξεργασμένων), καλύπτοντας εφαρμογές από την πρωτογενή συσκευασία σε κονσέρβες και βάζα έως τις δευτερογενείς λύσεις end-of-line.",
      en: "TFT offers solutions for fruit & vegetable packaging (fresh and processed), covering applications from primary packaging in cans and jars to secondary end-of-line solutions."
    },
    packaging: [
      { 
        product: { el: "Λαχανικά/φρούτα σε κονσέρβες", en: "Canned vegetables/fruits" }, 
        type: { el: "Πλήρωση & σφράγιση κονσερβών", en: "Can filling & seaming" }, 
        capacity: { el: "Μεσαία & υψηλή δυναμικότητα", en: "Medium & high capacity" }
      },
      { 
        product: { el: "Σάλτσες/προϊόντα ντομάτας", en: "Sauces/tomato products" }, 
        type: { el: "Γυάλινα & PET μπουκάλια", en: "Glass & PET bottles" }, 
        capacity: { el: "Μεσαία & υψηλή δυναμικότητα", en: "Medium & high capacity" }
      }
    ]
  },
  "ready-meals": {
    overview: {
      el: "Η TFT προσφέρει λύσεις για την παραγωγή και συσκευασία έτοιμων γευμάτων (chilled & frozen), με εξοπλισμό που καλύπτει από τη θερμική επεξεργασία και κατάψυξη έως την πρωτογενή και δευτερογενή συσκευασία.",
      en: "TFT offers solutions for ready meal production and packaging (chilled & frozen), with equipment covering thermal processing and freezing to primary and secondary packaging."
    },
    process: [
      { 
        name: { el: "Συστήματα Μαγειρέματος", en: "Cooking Systems" }, 
        features: { el: "Ακριβής έλεγχος θερμοκρασίας, batch & continuous", en: "Precise temperature control, batch & continuous" }
      },
      { 
        name: { el: "Συστήματα Κατάψυξης", en: "Freezing Systems" }, 
        features: { el: "Διατήρηση ποιότητας, ενεργειακή απόδοση", en: "Quality preservation, energy efficiency" }
      }
    ],
    packaging: [
      { 
        product: { el: "Έτοιμα γεύματα", en: "Ready meals" }, 
        type: { el: "Δίσκοι, θερμοδιαμορφωμένα πακέτα", en: "Trays, thermoformed packs" }, 
        capacity: { el: "Μεσαία & υψηλή δυναμικότητα", en: "Medium & high capacity" }
      }
    ]
  }
};
